import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CauseEffectService {

  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {
  }

  getCauseEffectData(headerId: number): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //  return this.http.get<any[]>(this.baseUrl + 'show-cause-and-effects', { headers: header, params: { headerId: headerId } });
    return this.http.get<any[]>(this.O3CoreApiUrl + 'ATCauseAndEffects/ShowCauseAndEffect', { headers: header, params: { headerId: headerId } });
  }

  addCauseEffectData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    //  return this.http.post<any[]>(this.baseUrl + 'add-cause-and-effects', data, { headers: header });
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ATCauseAndEffects/AddCauseEffect', data, { headers: header });
  }

  updateCauseEffectData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any[]>(this.baseUrl + 'update-cauese-and-effects', data, { headers: header });
   return this.http.put<any[]>(this.O3CoreApiUrl + 'ATCauseAndEffects/updateCauseAndEffect', data, { headers: header });
  }

}


